import { experienceReducer as experiences } from './monetate-experience.reducer';

const experienceReducers = { experiences };

export { experienceReducers };
